import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a7f9e21e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "summary"
}
const _hoisted_6 = { class: "status-wrap" }
const _hoisted_7 = { class: "control cm-ui-mr15" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" }, null, -1))
const _hoisted_10 = {
  key: 1,
  style: {"white-space":"nowrap"}
}
const _hoisted_11 = {
  key: 0,
  class: "statistics"
}
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "count cm-ui-txt-cte" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "count cm-ui-txt-cte" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "count cm-ui-txt-cte" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "count cm-ui-txt-cte" }
const _hoisted_20 = { class: "control" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailDrawer = _resolveComponent("DetailDrawer")!
  const _component_ExportDropdown = _resolveComponent("ExportDropdown")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Keywords = _resolveComponent("Keywords")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_RawDataDrawer = _resolveComponent("RawDataDrawer")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DetailDrawer, {
      modelValue: _ctx.state.detailDrawser,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.detailDrawser) = $event)),
      row: _ctx.state.row,
      type: _ctx.state.detailTypeName,
      onUpdate: _cache[1] || (_cache[1] = (row, key, count) => _ctx.handleEvent('updata-count', {row, key, count}))
    }, null, 8, ["modelValue", "row", "type"]),
    _createVNode(_component_ContentAdaptLayout, { class: "cm-ui-shadow-container cm-ui-pt16 cm-ui-pb16" }, {
      header: _withCtx(() => [
        _createVNode(_component_SearchFilterBar, {
          style: {"padding":"0 16px","background-color":"transparent"},
          modelValue: _ctx.queryParams,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.queryParams) = $event)),
          "form-columns": _ctx.filterFormColumns,
          "show-search": false,
          "popover-threshold": 2,
          onQuery: _ctx.handleQuery,
          onReset: _ctx.handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_ExportDropdown, {
              "button-text-i18n-key": "noticeManage.exportRecord",
              onExport: _ctx.download
            }, null, 8, ["onExport"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "onQuery", "onReset"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_LoadMoreButton, {
          loading: _ctx.data.loading,
          current: _ctx.data.list.length,
          class: "cm-ui-ml16 cm-ui-mr16",
          total: _ctx.data.total,
          onLoadMore: _ctx.loadMoreData
        }, null, 8, ["loading", "current", "total", "onLoadMore"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          data: _ctx.data.list,
          width: "100%",
          height: "100%",
          style: {"padding":"0 16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "create_time",
              label: _ctx.$t('noticeManage.createTime'),
              width: "160"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatTime(scope.row.create_time)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "sender",
              label: _ctx.$t('noticeManage.publisher'),
              width: "160",
              "min-width": "160"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "task",
              label: _ctx.$t('noticeManage.taskName'),
              width: "160",
              "min-width": "160"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.taskNameMap[scope.row.task_type] || "--"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "detail",
              label: _ctx.$t('noticeManage.summaryInfo')
            }, {
              default: _withCtx((scope) => [
                ([42,40].includes(scope.row.task_type) && (_ctx.parseArrayOnly(scope.row.detail)?.length ?? 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.fileMd5Label')) + " ", 1),
                      ((_ctx.parseArrayOnly(scope.row.detail)?.length ?? 0))
                        ? (_openBlock(), _createBlock(_component_Keywords, {
                            key: 0,
                            "max-count": 1,
                            keywords: _ctx.parseArrayOnly(scope.row.detail) ?? []
                          }, null, 8, ["keywords"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "--"))
                    ]))
                  : ([41,43].includes(scope.row.task_type) && (_ctx.parseArrayOnly(scope.row.detail)?.length ?? 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.filePathLabel')) + " ", 1),
                        ((_ctx.parseArrayOnly(scope.row.detail)?.length ?? 0))
                          ? (_openBlock(), _createBlock(_component_Keywords, {
                              key: 0,
                              maxChars: 20,
                              "max-count": 1,
                              keywords: _ctx.parseArrayOnly(scope.row.detail) ?? []
                            }, null, 8, ["keywords"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(scope.row.detail || "--"), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "status",
              "min-width": 100,
              label: _ctx.$t('noticeManage.deliverStatus'),
              align: "left"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", _hoisted_7, [
                    (scope.row.unexecuted_count === 0)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "success",
                          onClick: () => _ctx.handleColumn('finish', scope.row)
                        }, [
                          _hoisted_9,
                          _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.complete')), 1)
                        ], 8, _hoisted_8))
                      : (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_ctx.$t('noticeManage.sending')), 1))
                  ]),
                  (!_ctx.isTerminalInfo)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('noticeManage.targetCount')), 1),
                          _createElementVNode("div", _hoisted_13, "（" + _toDisplayString(scope.row.success_count + scope.row.unexecuted_count + scope.row.failed_count) + "）", 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('noticeManage.sendSuccess')), 1),
                          _createElementVNode("div", _hoisted_15, "（" + _toDisplayString(scope.row.success_count) + "）", 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('noticeManage.pendingSend')), 1),
                          _createElementVNode("div", _hoisted_17, "（" + _toDisplayString(scope.row.unexecuted_count) + "）", 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('noticeManage.failed')), 1),
                          _createElementVNode("div", _hoisted_19, "（" + _toDisplayString(scope.row.failed_count) + "）", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_20, [
                    _createElementVNode("li", {
                      class: "detail",
                      onClick: () => _ctx.handleColumn('detail', scope.row)
                    }, _toDisplayString(_ctx.$t('noticeManage.detail')), 9, _hoisted_21),
                    (!_ctx.isTerminalInfo && scope.row.unexecuted_count > 0)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "detail cm-ui-ml10",
                          onClick: () => _ctx.handleColumn('cancel', scope.row)
                        }, _toDisplayString(_ctx.$t('common.cancel')), 9, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('noticeManage.operation'),
              width: "100",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: "cm-link-light underline",
                  onClick: ($event: any) => (_ctx.showRawData(scope.row))
                }, _toDisplayString(_ctx.$t('noticeManage.rawData')), 9, _hoisted_23)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "data"])), [
          [_directive_loading, _ctx.data.loading],
          [_directive_load_more, _ctx.loadMoreData]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_RawDataDrawer, {
      modelValue: _ctx.isShowRawData,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowRawData) = $event)),
      "raw-data": _ctx.currentRow
    }, null, 8, ["modelValue", "raw-data"])
  ], 64))
}